
import React from 'react';
import { ConfirmingReportItemValidationsModalTemplate } from 'themes/application/confirming-report/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { ConfirmingReportItemValidationsModalViewStore } from 'application/confirming-report/stores';

@setCurrentView((rootStore, componentProps) => new ConfirmingReportItemValidationsModalViewStore(rootStore, componentProps), 'confirmingReportItemValidationsModalViewStore')
@observer
class ConfirmingReportItemValidationsModal extends React.Component {
    render() {
        return <ConfirmingReportItemValidationsModalTemplate {...this.props} />
    }
}

export default ConfirmingReportItemValidationsModal;
